// import { useContext } from 'react'
// import { GlobalContext } from '../../../context/Context';
import { motion } from "framer-motion";
import { TrendingUp, AlertCircle } from 'lucide-react';
import { Database, Bank, Benefit, Branch, CarModel, CarName, CarRegistration, CarVariant, CNIC, Date, DateOfConfirmation, DateOfExpiry, DateOfJoining, DefaultIcon, DegreeMajors, DegreeTitle, Depart, Designation, Driver, Education, Email, EmpType, Experience, FoodEligible, HiringReason, Holiday, Incident, InstituteName, JobSite, JobTitle, JobType, Meta, Month, Name, NoOfPosition, Notice, Phone, Platform, Position, Range, RationEligible, Reporting, Salary, Service, Shift, Skills, Status, Subject, TaxSlab, TicketCategory, TicketSubCategory, TicketType, Van, VendorType, Year } from "../../icons/filter-icon";

// const iconRules = [
//   { keys: ["job title"], Icon: JobTitle },
//   { keys: ["hiring reason"], Icon: HiringReason },
//   { keys: ["no of position", "number of position"], Icon: NoOfPosition },
//   { keys: ["position"], Icon: Position },
//   { keys: ["education"], Icon: Education },
//   { keys: ["skills"], Icon: Skills },
//   { keys: ["experience"], Icon: Experience },
//   { keys: ["platform"], Icon: Platform },
//   { keys: ["job site"], Icon: JobSite },
//   { keys: ["job type"], Icon: JobType },
//   { keys: ["branch"], Icon: Branch },
//   { keys: ["ticket type"], Icon: TicketType },
//   { keys: ["ticket category"], Icon: TicketCategory },
//   { keys: ["ticket sub category"], Icon: TicketSubCategory },
//   { keys: ["driver"], Icon: Driver },
//   { keys: ["incident"], Icon: Incident },
//   { keys: ["car model"], Icon: CarModel },
//   { keys: ["car variant"], Icon: CarVariant },
//   { keys: ["car name", 'car'], Icon: CarName },
//   { keys: ["tax", 'tax slab'], Icon: TaxSlab },
//   { keys: ["foodpanda eligible"], Icon: FoodEligible },
//   { keys: ["ration eligible"], Icon: RationEligible },
//   { keys: ["date of confirmation", "confirmation date", "conform date"], Icon: DateOfConfirmation },
//   { keys: ["date of joining", "joining date"], Icon: DateOfJoining },
//   { keys: ["date of expiry", "expiry date"], Icon: DateOfExpiry },
//   { keys: ["cnic"], Icon: CNIC },
//   { keys: ["bank"], Icon: Bank },
//   { keys: ["email"], Icon: Email },
//   { keys: ["degree title"], Icon: DegreeTitle },
//   { keys: ["service"], Icon: Service },
//   { keys: ["degree major", "degree majors"], Icon: DegreeMajors },
//   { keys: ["employee type"], Icon: EmpType },
//   { keys: ["department", "depart", "dept"], Icon: Depart },
//   { keys: ["designation"], Icon: Designation },
//   { keys: ["status"], Icon: Status },
//   { keys: ["notice"], Icon: Notice },
//   { keys: ["shift"], Icon: Shift },
//   { keys: ["reporting", "authority"], Icon: Reporting },
//   { keys: ["meta"], Icon: Meta },
//   { keys: ["holiday"], Icon: Holiday },
//   { keys: ["salary", "amount", 'rent'], Icon: Salary },
//   { keys: ["benefit"], Icon: Benefit },
//   { keys: ["phone", "mobile", "contact"], Icon: Phone },
//   { keys: ["month"], Icon: Month },
//   { keys: ["year"], Icon: Year },
//   { keys: ["range"], Icon: Range },
//   { keys: ["van"], Icon: Van },
//   { keys: ["date"], Icon: Date },
//   { keys: ['subject'], Icon: Subject },
//   { keys: ["car registration", 'registration'], Icon: CarRegistration },
//   { keys: ["institute name", "institute", "school", "college"], Icon: InstituteName },
//   { keys: ["name", "employee", "emp", "employ"], Icon: Name },
//   { keys: ['type', 'vendor type'], Icon: VendorType },
//   { keys: ["ticket"], Icon: TicketType },
// ];

const DataNotFound = ({
  title,
  content,
  className,
  IconSVG = null,
  isIcon = false,
  duration = 4,
  onlyText = false,
  onlyIcon = false
  // iconURL,
  // width = 320,   // ✅ default width
  // height = 240   // ✅ default height
}) => {

  // const getFilterIcon = (filter) => {
  //   const text = (filter || "")
  //     .toLowerCase()
  //     .replace(/[_-]/g, " ");

  //   const rule = iconRules.find(rule =>
  //     rule.keys.some(key => text.includes(key))
  //   );

  //   return rule?.Icon || Database;
  // };

  const ResolvedIcon = IconSVG ? IconSVG : Database;

  return (
    onlyText ? (
      <p className={`noDataFound ${className}`}>
        {content ? (
          <>{content}</>
        ) : (
          <>
            No <span>{title}</span> Found
          </>
        )}
      </p>
    ) : (onlyIcon) ? (
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ duration: 0.4 }}
        className={`flex flex-col items-center justify-center pt-[72px] pb-4 px-4 w-full h-full ${className}`}
      >
        <motion.div
          animate={{
            y: [0, -8, 0],
          }}
          transition={{
            duration: duration,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
          className="relative mb-6"
        >
          {/* Background glow */}
          {/* <motion.div
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.3, 0.6, 0.3],
            }}
            transition={{
              duration: duration,
              repeat: Infinity,
              ease: 'easeInOut',
            }}
            className="absolute inset-0 bg-gradient-to-br from-slate-400 to-[#1C1F20] rounded-full blur-xl"
          /> */}
          <motion.div
            animate={{
              scale: [1.1, 0.8, 1.1],
              opacity: [0.6, 0.3, 0.6],
            }}
            transition={{
              duration,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            className="absolute inset-0 rounded-full bg-gradient-to-tr from-cyan-200 via-blue-300 to-indigo-400 blur-xl"
          />

          {/* Icon container */}
          <motion.div
            animate={{
              rotate: [0, 3, -3, 0],
            }}
            transition={{
              duration: duration + duration / 2,
              repeat: Infinity,
              ease: 'easeInOut',
            }}
            className="relative w-24 h-24 bg-gradient-to-br from-gray-100 to-gray-50 rounded-2xl flex items-center justify-center shadow-lg &svg:!w-12"
          >
            <div className="w-12 h-12 [&>svg]:w-full [&>svg]:h-full [&_path[stroke]]:stroke-gray-400 text-gray-400">
              {ResolvedIcon && <ResolvedIcon strokeWidth={1.5} />}
            </div>

            {/* Floating decorative elements */}
            <motion.div
              animate={{
                y: [0, -15, 0],
                opacity: [0.5, 1, 0.5],
              }}
              transition={{
                duration: duration,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: 0.5,
              }}
              className="absolute -top-3 -right-3"
            >
              <TrendingUp className="w-6 h-6 text-purple-400" />
            </motion.div>

            <motion.div
              animate={{
                y: [0, 12, 0],
                opacity: [0.5, 1, 0.5],
              }}
              transition={{
                duration: duration,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: 1,
              }}
              className="absolute -bottom-2 -left-2"
            >
              <AlertCircle className="w-5 h-5 text-blue-400" />
            </motion.div>
          </motion.div>
        </motion.div>

        {/* Text */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-center space-y-1"
        >
          <h3 className="text-lg font-semibold text-gray-900">No Data Found</h3>
          {/* <p className="text-sm text-gray-500 max-w-xs">
            {content ? (
              <>{content}</>
            ) : (
              <>
                No <span className="font-bold">{title}</span> Found
              </>
            )}
          </p> */}
        </motion.div>

        {/* Decorative lines */}
        {/* <motion.div
          initial={{ width: 0 }}
          animate={{ width: '100%' }}
          transition={{ delay: 0.4, duration: 0.6 }}
          className="mt-6 h-px flex-shrink-0 bg-gradient-to-r from-transparent via-gray-300 to-transparent max-w-xs"
        /> */}

        {/* Suggestion */}
        {/* <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="mt-4 text-xs text-gray-400 text-center"
        >
          Try adjusting your filters or refreshing the data
        </motion.p> */}
      </motion.div>
    ) : (
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ duration: 0.4 }}
        className={`flex flex-col items-center justify-center pt-[72px] pb-4 px-4 w-full h-full ${className}`}
      >
        <motion.div
          animate={{
            y: [0, -8, 0],
          }}
          transition={{
            duration: duration,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
          className="relative mb-6"
        >
          {/* Background glow */}
          {/* <motion.div
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.3, 0.6, 0.3],
            }}
            transition={{
              duration: duration,
              repeat: Infinity,
              ease: 'easeInOut',
            }}
            className="absolute inset-0 bg-gradient-to-br from-slate-400 to-[#1C1F20] rounded-full blur-xl"
          /> */}
          <motion.div
            animate={{
              scale: [1.1, 0.8, 1.1],
              opacity: [0.6, 0.3, 0.6],
            }}
            transition={{
              duration,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            className="absolute inset-0 rounded-full bg-gradient-to-tr from-cyan-200 via-blue-300 to-indigo-400 blur-xl"
          />

          {/* Icon container */}
          <motion.div
            animate={{
              rotate: [0, 3, -3, 0],
            }}
            transition={{
              duration: duration + duration / 2,
              repeat: Infinity,
              ease: 'easeInOut',
            }}
            className="relative w-24 h-24 bg-gradient-to-br from-gray-100 to-gray-50 rounded-2xl flex items-center justify-center shadow-lg &svg:!w-12"
          >
            <div className="w-12 h-12 [&>svg]:w-full [&>svg]:h-full [&_path[stroke]]:stroke-gray-400 text-gray-400">
              {ResolvedIcon && <ResolvedIcon strokeWidth={1.5} />}
            </div>

            {/* Floating decorative elements */}
            <motion.div
              animate={{
                y: [0, -15, 0],
                opacity: [0.5, 1, 0.5],
              }}
              transition={{
                duration: duration,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: 0.5,
              }}
              className="absolute -top-3 -right-3"
            >
              <TrendingUp className="w-6 h-6 text-purple-400" />
            </motion.div>

            <motion.div
              animate={{
                y: [0, 12, 0],
                opacity: [0.5, 1, 0.5],
              }}
              transition={{
                duration: duration,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: 1,
              }}
              className="absolute -bottom-2 -left-2"
            >
              <AlertCircle className="w-5 h-5 text-blue-400" />
            </motion.div>
          </motion.div>
        </motion.div>

        {/* Text */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-center space-y-1"
        >
          <h3 className="text-lg font-semibold text-gray-900">No Data Found</h3>
          <p className="text-sm text-gray-500 max-w-xs">
            {content ? (
              <>{content}</>
            ) : (
              <>
                No <span className="font-bold">{title}</span> Found
              </>
            )}
          </p>
        </motion.div>

        {/* Decorative lines */}
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: '100%' }}
          transition={{ delay: 0.4, duration: 0.6 }}
          className="mt-6 h-px flex-shrink-0 bg-gradient-to-r from-transparent via-gray-300 to-transparent max-w-xs"
        />

        {/* Suggestion */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="mt-4 text-xs text-gray-400 text-center"
        >
          Try adjusting your filters or refreshing the data
        </motion.p>
      </motion.div>
    )
  );
  // let { state } = useContext(GlobalContext);

  // return (
  //   <>
  //     {!isIcon ? (
  //       <p className={`noDataFound ${className}`}>
  //         {content ? (
  //           <>{content}</>
  //         ) : (
  //           <>
  //             No <span>{title}</span> Found
  //           </>
  //         )}
  //       </p>
  //     ) : (
  //       <div className="text-center flex flex-col items-center justify-center gap-2">
  //         {iconSVG ? (
  //           <div 
  //             className="icon-wrapper object-contain object-center max-h-[80%] max-w-[80%] m-auto"
  //             style={{
  //               width: `${width}px`,
  //               height: `${height}px`,
  //             }}
  //           >
  //             {iconSVG}
  //           </div>
  //         ) : (
  //           <img
  //             src={`${state.basePath}${iconURL}`}
  //             alt=""
  //             width={width}
  //             height={height}
  //             className="object-contain object-center max-h-[80%] max-w-[80%] m-auto"
  //           />
  //         )}

  //         <p className={`noDataFound ${className}`}>
  //           {content ? (
  //             content
  //           ) : (
  //             <>
  //               No <span>{title}</span> Found
  //             </>
  //           )}
  //         </p>
  //       </div>
  //     )}
  //   </>
  // );
};

export default DataNotFound;